<template>
  <el-config-provider :locale="zhCn">
    <MainLayout/>
  </el-config-provider>
</template>

<script setup lang="ts">
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import MainLayout from './views/Layout/MainLayout.vue'
</script>